import Vue from 'vue';
import {Observable} from 'rxjs';
import gql from 'graphql-tag';
import { PRODUCT_FIELDS } from '../constants/productFields';

export function getProducts (paramsObservable) {
    return new Observable(subscriber => {
        let paramsSubscriber;
        let unwatchers = new Set();
        unwatchers.unwatch = function() {
            this.forEach(unwatcher => unwatcher());
        };

        paramsSubscriber = paramsObservable.subscribe(params => {
            handleProductsLoad(preparePriceParams(params), subscriber);

            unwatchers.unwatch();

            unwatchers.add(Vue.$store.watch(() => Vue.$country.getCountry(), (val) => {
                handleProductsLoad(preparePriceParams(params), subscriber);
            }));
            unwatchers.add(Vue.$store.watch(() => Vue.$currency.getSelected(), (val) => {
                handleProductsLoad(preparePriceParams(params), subscriber);
            }));
        });

        return function unsubscribe() {
            paramsSubscriber.unsubscribe();
            unwatchers.unwatch();
        };
    });
};

function preparePriceParams (params) {
    let options = Object.assign({}, params);
    if (options.priceParams && options.priceParams.length) {
        options.priceParams.forEach(priceParam => {
            if (!priceParam.country && !priceParam.country_id) {
                priceParam.country = Vue.$country.getCountry();
            }
            priceParam.currency = Vue.$currency.getSelected();
        });
    } else {
        options.priceParams = [];
        if (!params.skipPriceParams) {
            options.priceParams = [{
                country: Vue.$country.getCountry(),
                currency: Vue.$currency.getSelected(),
            }];
        }
    }

    return options;
};

function handleProductsLoad (options, subscriber) {
    if ((options.ids && options.ids.length > 0) || options.categories && options.categories.length > 0) {
        loadProducts(options).then(r => {
            subscriber.next(r);
        });
    } else {
        subscriber.next([]);
    }
};

export async function loadProducts(options) {
    let ids = options.ids.filter(Boolean);
    ids = ids.map(id => {
        return id.toString();
    });

    let fields = options.fields || PRODUCT_FIELDS;

    return Vue.$graphql
        .query({
            query: gql(`
                query products(
                    $productIds: [String!]!,
                    $priceParams: [JSON!]!,
                    $categories: [Int!],
                    $categoryProductsLimit: Int,
                    $unacceptableProducts: [String!],
                    $language: String,
                ) {
                    products(
                        productIds: $productIds,
                        priceParams: $priceParams,
                        categories: $categories,
                        categoryProductsLimit: $categoryProductsLimit,
                        unacceptableProducts: $unacceptableProducts,
                        language: $language,
                    ) {
                        ${fields}
                    }
                }
            `),
            variables: {
                productIds: ids,
                priceParams: options.priceParams,
                categories: options.categories ? options.categories : [],
                categoryProductsLimit: options.categoryProductsLimit ? options.categoryProductsLimit : null,
                unacceptableProducts: options.unacceptableProducts ? options.unacceptableProducts : [],
                language: Vue.$language.getLanguage(),
            },
            fetchPolicy: options.hasOwnProperty('priceParams') ? 'no-cache' : 'cache-first'
        })
        .then(r => {
            let result = [];
            r.data.products.forEach(dataProduct => {
                let product = Object.assign({}, dataProduct);
                if (product.merchant) {
                    let indexedMerchants = {};
                    product.merchant.forEach(merchant => {
                        indexedMerchants[merchant.id] = merchant;
                    });
                    product.merchant = indexedMerchants;
                }
                result.push(product);
            });

            return result;
        });
};